import { createFileRoute } from "@tanstack/react-router";
import CalendarView from "@/components/logistics/containers/calendar/calendar-view";

export const Route = createFileRoute(
  "/_authenticated/logistics/containers/_list/calendar",
)({
  component: ConsolidadosCalendarPage,
});

function ConsolidadosCalendarPage() {
  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <CalendarView />
    </div>
  );
}
